import React, { useState, useEffect } from "react";
import { Grid, Typography } from '@material-ui/core';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next"
import { WebSessionContextProvider } from "@switch/core";
import Api from "../../Api";
import { Redirect } from "./Redirect";

export function HeyCentricResultHandler() {
    let [searchParams] = useSearchParams();

    let session = searchParams.get("SID");
    let authCode = searchParams.get("AuthCode");    
    let cardType = searchParams.get("CardTyp");
    let Pmt = searchParams.get("Pmt");
    let Rc = searchParams.get("Rc");
    let RecNo = searchParams.get("RecNo");
    let result = searchParams.get("result");

    const { t, i18n } = useTranslation();

    const [processed, setProcessed] = useState(false);

    const API = new Api(
        {
            urlRoot: window.location.origin + "/Dispace/Switch/1.0.0/",
            widgetKey: session
        });


    useEffect(() => {
        if (!session) return;

        const outcome = {
            session,
            authCode,
            result,
            cardType,
            Pmt,
            Rc,
            RecNo
        };


        API.ProcessHeyCentricResult(session, outcome).then((data) => { setProcessed(true) });
    }, [result])

    return (
        <WebSessionContextProvider dataProvider={API} sessionKey={session}>
            <Grid container direction="row" justify="center" alignItems="flex-start">
                <Typography>{t("switch.widget.payresult.complete")}</Typography>
                <Redirect processed={processed} />
            </Grid>
        </WebSessionContextProvider>
    )
}